// extracted by mini-css-extract-plugin
export default {"box":"fouP_I_cE9o","boxOverflowGradient":"fouBPo_4aY7","expanded":"foue8JjWfjo","transition":"fouk7lmtkvh"};